import React from "react";
import { Tooltip, Box, Typography, Button } from "@mui/material";
import { CustomButtonProps } from "./buttons.model";
import { StyledButton } from "./custom-button";

export const CustomButton: React.FC<CustomButtonProps> = ({
  onClick,
  tooltip = "",
  placement = "center",
  errorMessage = "",
  helperText = "",
  icon,
  iconPosition = "start",
  label,
  variant = "text",
  size = "small",
  color = "warning",
  ...props
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems:
          placement === "left"
            ? "flex-start"
            : placement === "right"
              ? "flex-end"
              : "center",
        gap: 1,
      }}
    >
      <Tooltip title={tooltip} placement="top" arrow>
        <Button
          {...props}
          variant={variant}
          size={size}
          color={color}
          onClick={onClick}
          startIcon={iconPosition === "start" ? icon : null}
          endIcon={iconPosition === "end" ? icon : null}
        >
          {label}
        </Button>
      </Tooltip>
      {helperText && (
        <Typography
          variant="body2"
          sx={{
            color: "#6c757d", // Helper text color
            fontSize: "0.85rem",
          }}
        >
          {helperText}
        </Typography>
      )}
      {errorMessage && (
        <Typography
          variant="body2"
          sx={{
            color: "red",
            fontSize: "0.85rem",
          }}
        >
          {errorMessage}
        </Typography>
      )}
    </Box>
  );
};
